export default __webpack_public_path__ + "759e1963a1c1332df429be43a0d7a5e3.svg";